// 系统信息：管理后台顶部导航栏的系统名称 / Logo，以及浏览器标签页图标
// 后台「系统设置 → 系统信息」保存到 sysConfig，这里统一读取并应用到 DOM
import { ref } from 'vue'
import { getPublicConfig } from '../api'

// 未配置时的默认值
export const DEFAULT_SITE_NAME = '海鲜生鲜商城管理后台'
// 内置图标：public/logo.svg（与顶部导航栏 LogoIcon 同一份图形），同时用作默认网站图标
export const DEFAULT_LOGO = './logo.svg'

export const siteInfo = ref({
  name: DEFAULT_SITE_NAME,
  logo: '',
  favicon: ''
})

// 把系统名称写进标题、网站图标写进 <link rel="icon">
function applyToDom() {
  const name = siteInfo.value.name || DEFAULT_SITE_NAME
  document.title = name

  const href = siteInfo.value.favicon || DEFAULT_LOGO
  let link = document.querySelector('link[rel="icon"]')
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.href = href

  // 「添加到主屏幕」图标：iOS 不识别 SVG，优先用系统设置里的位图 Logo，否则用内置 PNG
  const pickRaster = (v) => (v && !/\.svg(\?|#|$)/i.test(v) ? v : '')
  const touchIcon = pickRaster(siteInfo.value.logo) || pickRaster(siteInfo.value.favicon) || './logo-180.png'
  let touch = document.querySelector('link[rel="apple-touch-icon"]')
  if (!touch) {
    touch = document.createElement('link')
    touch.rel = 'apple-touch-icon'
    document.head.appendChild(touch)
  }
  touch.href = touchIcon

  // 主屏应用名跟随系统名称
  const appTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]')
  if (appTitle) appTitle.setAttribute('content', name)
}

// 读取配置并应用；失败时保持默认值，不影响页面使用
export async function loadSiteInfo() {
  try {
    const res = await getPublicConfig()
    const data = res.data || {}
    siteInfo.value = {
      name: String(data.siteName || '').trim() || DEFAULT_SITE_NAME,
      logo: String(data.siteLogo || '').trim(),
      favicon: String(data.siteFavicon || '').trim()
    }
  } catch (e) {
    // 接口异常时沿用当前值（默认值）
  }
  applyToDom()
}
